import { FormControl, FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
import { ChangeEvent } from "react";
import { Colors } from "../../helpers/Consts";

type Props = {
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>, value: string)=>void;
}

export default function SelectDeliveryMode({ value, onChange }: Props) {
  return (
    <FormControl
      sx={{
        display: "flex",
        width: "100%",
        flexGrow: 1,
      }}
    >
      <RadioGroup name={"deliveryMode"} value={value} onChange={onChange}>
        <FormControlLabel
          value={'delivery'}
          control={<Radio size="medium" />}
          labelPlacement="start"
          label={
            <Typography
              fontSize="14px"
              fontWeight={700}
              sx={{ flexGrow: 1, }}
              color={
                value !== "Delivery"
                  ? Colors.baseTextColor
                  : "primary"
              }
            >
              Delivery
            </Typography>
          }
        />

        <FormControlLabel
          value={'retirada'}
          control={<Radio size="medium" />}
          labelPlacement="start"
          label={
            <Typography
              fontSize="14px"
              fontWeight={700}
              sx={{ flexGrow: 1, }}
              color={
                value !== "Retirada"
                  ? Colors.baseTextColor
                  : "primary"
              }
            >
              Retirada
            </Typography>
          }
        />

      </RadioGroup>
    </FormControl>
  )
}